var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5404 6.49844C22.2874 5.51496 21.542 4.74054 20.5954 4.47768C18.8796 4 12 4 12 4C12 4 5.12041 4 3.40458 4.47768C2.45815 4.74054 1.7126 5.51496 1.45964 6.49844C1 8.28094 1 12.0001 1 12.0001C1 12.0001 1 15.7192 1.45964 17.5016C1.7126 18.485 2.45815 19.2597 3.40458 19.5225C5.12041 20 12 20 12 20C12 20 18.8796 20 20.5954 19.5225C21.542 19.2597 22.2874 18.485 22.5404 17.5016C23 15.7192 23 12.0001 23 12.0001C23 12.0001 23 8.28094 22.5404 6.49844ZM9.79989 15.4287V8.57147L15.5156 12.0001L9.79989 15.4287Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c3658c656bc2be70437b4d3de18f6332.svg";
export { ForwardRef as ReactComponent };